<template>
  <div>
    <template v-if="!hide">
      <!-- <span v-if="auth && auth.canEdit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="info"
              v-on="on"
              @click.stop="goTo(`/auditorias/${params.data.uuid}`)"
              >mdi-eye-outline</v-icon
            >
          </template>
          <span>Ver</span>
        </v-tooltip>
      </span> -->
        <span v-if="auth && auth.canClose && isOpen">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="success"
              v-on="on"
              @click.stop="confirmClose = true"
              >mdi-check-circle-outline</v-icon
            >
          </template>
          <span>Cerrar</span>
        </v-tooltip>
      </span>
      <span v-if="auth && auth.canOpen && isClosed">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="success"
              v-on="on"
              @click.stop="openItem()"
              >mdi-open-in-new</v-icon
            >
          </template>
          <span>Abrir</span>
        </v-tooltip>
      </span>
      <span v-if="auth && auth.canDelete && canDelete">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="error"
              v-on="on"
              @click.stop="confirmDelete = true"
              >mdi-delete-outline</v-icon
            >
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </span>
    
    </template>

    <!-- Confirmación -->

    <confirmation
      v-model="confirmDelete"
      :text="'¿Eliminar auditoria?'"
      colorButton="error"
      @confirm="deleteItem()" />

    <confirmation
      v-model="confirmClose"
      :text="'Se debe cerrar la auditoría cuando el checklist, pacs, y muestras estén realizados totalmente. No se podrá volver a abrir ¿Está seguro de cerrar la auditoría?'"
      colorButton="error"
      textButton="Cerrar"
      @confirm="closeItem()" />
      
  </div>
</template>

<script>
import Confirmation from '~/components/Confirmation'
export default {
  components: {
    Confirmation,
  },
  data: function () {
    return {
      confirmAprobar: false,
      confirmDelete: false,
      confirmClose: false,
      auth: {},
    }
  },
  computed: {
    isOpen() {
      return this.params.data.estado == 'ABIERTA'
    },
    isClosed() {
      return this.params.data.estado == 'REALIZADA' || this.params.data.estado == 'CERRADA'
    },
    canDelete() {
      return true
    },
    IS_LIST() {
      return !this.$route.params.uuid
    },
    CAN_EDIT() {
      return this.IS_LIST ? this.$store.state.permisos.can_edit : true
    },
    CAN_DELETE() {
      return this.IS_LIST ? this.$store.state.permisos.can_delete : true
    },
    isNotGroup() {
      return !!this.params.data
    },
    hide() {
      return this.params.value === true
    },
  },
  methods: {
    init() {
      if (this.params.init instanceof Function) this.params.init()
    },
    goTo(path) {
      this.$router.push(path)
    },
    async deleteItem() {
      this.confirmDelete = false
      let gridOptions = this.$parent.gridOptions
      let gridApi = this.$parent.gridOptions.api
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`auditorias/delete`, this.params.node.data).then(() => {
          console.log('gridApi', gridApi)
          gridApi.purgeServerSideCache()
          gridApi.refreshCells()
          this.$store.commit('notification/show', {
            text: 'Auditoria eliminada correctamente',
            color: 'success',
            timeout: 3000,
          })
        })
        this.init()
      }
    },
    async closeItem() {
      this.confirmClose = false
      let gridOptions = this.$parent.gridOptions
      let gridApi = this.$parent.gridOptions.api
      this.params.node.data.estado = 'CERRADA'
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`auditorias/cambiarEstado`, this.params.node.data).then(() => {
          console.log('gridApi', gridApi)
          gridApi.purgeServerSideCache()
          gridApi.refreshCells()
          this.$store.commit('notification/show', {
            text: 'Auditoria cerrada correctamente',
            color: 'success',
            timeout: 3000,
          })
        })
        this.init()
      }
    },
    async openItem() {
      this.confirmClose = false
      let gridOptions = this.$parent.gridOptions
      let gridApi = this.$parent.gridOptions.api
      this.params.node.data.estado = 'ABIERTA'
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`auditorias/cambiarEstado`, this.params.node.data).then(() => {
          console.log('gridApi', gridApi)
          gridApi.purgeServerSideCache()
          gridApi.refreshCells()
          this.$store.commit('notification/show', {
            text: 'Auditoria abierta correctamente',
            color: 'success',
            timeout: 3000,
          })
        })
        this.init()
      }
    },
    async checkRoles() {
      this.auth = await this.$store.dispatch('user/can', {
        module: 'auditorias',
        submodule: 'auditorias',
        return: 'all',
      })
      console.log('auth', this.auth)
    },
  },

  async mounted() {
    this.checkRoles()
  },
}
</script>
